module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 116);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@splunk/themes");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 100:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/ControlGroup");

/***/ }),

/***/ 101:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/Search");

/***/ }),

/***/ 116:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ src_Text_Text; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(1);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "react-event-listener"
var external_react_event_listener_ = __webpack_require__(15);
var external_react_event_listener_default = /*#__PURE__*/__webpack_require__.n(external_react_event_listener_);

// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(4);

// EXTERNAL MODULE: external "@splunk/ui-utils/style"
var style_ = __webpack_require__(40);

// EXTERNAL MODULE: external "@splunk/react-ui/ScreenReaderContent"
var ScreenReaderContent_ = __webpack_require__(14);
var ScreenReaderContent_default = /*#__PURE__*/__webpack_require__.n(ScreenReaderContent_);

// EXTERNAL MODULE: external "@splunk/themes"
var themes_ = __webpack_require__(0);

// EXTERNAL MODULE: external "@splunk/react-ui/ControlGroup"
var ControlGroup_ = __webpack_require__(100);

// EXTERNAL MODULE: external "@splunk/ui-utils/i18n"
var i18n_ = __webpack_require__(5);

// EXTERNAL MODULE: external "@splunk/react-icons/Search"
var Search_ = __webpack_require__(101);
var Search_default = /*#__PURE__*/__webpack_require__.n(Search_);

// EXTERNAL MODULE: ./src/icons/ThemedIcon.tsx
var ThemedIcon = __webpack_require__(7);

// EXTERNAL MODULE: ./src/icons/SVG.tsx
var SVG = __webpack_require__(6);

// CONCATENATED MODULE: ./src/icons/Search.tsx
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






function Prisma24(_ref) {
  var otherProps = _extends({}, _ref);

  return /*#__PURE__*/external_react_default.a.createElement(SVG["a" /* default */], _extends({
    viewBox: "0 0 24 24"
  }, otherProps), /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "M10.5,3.0015 C14.6421,3.0015 18,6.3593 18,10.5015 C18,12.2112 17.4279,13.7873 16.4647,15.0489 L20.7077,19.292 C21.0983,19.6825 21.0983,20.3156 20.7077,20.7062 C20.3172,21.0967 19.6841,21.0967 19.2935,20.7062 L15.0509,16.4635 C13.7888,17.4283 12.2113,18.0015 10.5,18.0015 C6.3579,18.0015 3,14.6436 3,10.5015 C3,6.3593 6.3579,3.0015 10.5,3.0015 Z M10.5,5.0015 C7.4624,5.0015 5,7.4639 5,10.5015 C5,13.539 7.4624,16.0015 10.5,16.0015 C13.5376,16.0015 16,13.539 16,10.5015 C16,7.4639 13.5376,5.0015 10.5,5.0015 Z",
    fill: "currentColor"
  }));
}

function Prisma16(_ref2) {
  var otherProps = _extends({}, _ref2);

  return /*#__PURE__*/external_react_default.a.createElement(SVG["a" /* default */], _extends({
    viewBox: "0 0 16 16"
  }, otherProps), /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "M6.85277,2.0015 C9.53288,2.0015 11.7055,4.1741 11.7055,6.8542 C11.7055,7.8463 11.4079,8.7688 10.897,9.5373 L10.9245,9.5098 L14.0018,12.5871 L12.5876,14.0014 L9.51025,10.924 L9.53587,10.8984 C8.76733,11.4093 7.84481,11.707 6.85277,11.707 C4.17266,11.707 2,9.5343 2,6.8542 C2,4.1741 4.17266,2.0015 6.85277,2.0015 Z M6.85277,4.0015 C5.27723,4.0015 4,5.2787 4,6.8542 C4,8.4298 5.27723,9.707 6.85277,9.707 C8.42831,9.707 9.70554,8.4298 9.70554,6.8542 C9.70554,5.2787 8.42831,4.0015 6.85277,4.0015 Z",
    fill: "currentColor"
  }));
}

function Search(props) {
  return /*#__PURE__*/external_react_default.a.createElement(ThemedIcon["a" /* default */], _extends({
    Enterprise: Search_default.a,
    Prisma16: Prisma16,
    Prisma24: Prisma24
  }, props));
}
// EXTERNAL MODULE: ./src/icons/CrossMark.tsx
var CrossMark = __webpack_require__(21);

// CONCATENATED MODULE: ./src/Text/syncHeightWithShadow.ts
// This file was adapted from [Call-Em-All's material-ui](https://github.com/mui-org/material-ui),
// which is MIT-licensed:
//
// The MIT License (MIT)
//
// Copyright (c) 2014 Call-Em-All
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
//
// End of MIT license text.
function syncHeightWithShadow(_ref) {
  var height = _ref.height,
      multiline = _ref.multiline,
      rowsMax = _ref.rowsMax,
      rowsMin = _ref.rowsMin,
      shadow = _ref.shadow;

  if (multiline && shadow) {
    var style = window.getComputedStyle(shadow);
    var lineHeightValue = style.getPropertyValue('line-height'); // jsdom does not properly inherit/re-calculate the line-height property so we skip in these cases SUI-1943, SUI-2428

    if (lineHeightValue === 'inherit' || lineHeightValue === 'normal') {
      return false;
    }

    var lineHeight = parseInt(lineHeightValue, 10);
    var paddingTop = parseInt(style.getPropertyValue('padding-top'), 10);
    var paddingBottom = parseInt(style.getPropertyValue('padding-bottom'), 10);
    var borderTop = parseInt(style.getPropertyValue('border-top-width'), 10);
    var borderBottom = parseInt(style.getPropertyValue('border-bottom-width'), 10);
    var newHeight = shadow.scrollHeight + borderTop + borderBottom;
    /* eslint-disable no-restricted-globals */
    // Leverage the global `isNaN` here for IE support, rather than Number.isNaN.
    // We know newHeight is numeric because we parseInt() above, so `isNaN` should be reliable.

    if (newHeight === undefined || isNaN(newHeight)) {
      return false;
    }
    /* eslint-enable no-restricted-globals */


    if (rowsMax >= rowsMin) {
      var maxHeight = rowsMax * lineHeight + paddingTop + paddingBottom + borderTop + borderBottom + 1; // need one extra.

      newHeight = Math.min(maxHeight, newHeight);
    }

    var minHeight = rowsMin * lineHeight + paddingTop + paddingBottom + borderTop + borderBottom + 1; // need one extra.

    newHeight = Math.max(minHeight, newHeight);

    if (height !== newHeight) {
      return newHeight;
    }
  }

  return false;
}
// EXTERNAL MODULE: ./src/utils/updateReactRef.ts
var updateReactRef = __webpack_require__(12);

// EXTERNAL MODULE: external "@splunk/react-icons/SVG"
var SVG_ = __webpack_require__(22);
var SVG_default = /*#__PURE__*/__webpack_require__.n(SVG_);

// CONCATENATED MODULE: ./src/Text/IconOutlinedHide.tsx
function IconOutlinedHide_extends() { IconOutlinedHide_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return IconOutlinedHide_extends.apply(this, arguments); }






function IconOutlinedHide(props) {
  var _useSplunkTheme = Object(themes_["useSplunkTheme"])(),
      family = _useSplunkTheme.family,
      density = _useSplunkTheme.density;

  if (family === 'enterprise') {
    return /*#__PURE__*/external_react_default.a.createElement(SVG_default.a, IconOutlinedHide_extends({
      viewBox: "0 0 24 24",
      size: 1.2,
      screenReaderText: Object(i18n_["_"])('Hide password')
    }, props), /*#__PURE__*/external_react_default.a.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.00691 3.89287C3.61638 3.50234 2.98322 3.50235 2.5927 3.89287C2.20217 4.2834 2.20217 4.91656 2.5927 5.30708L4.35908 7.07346C3.63043 7.75302 2.99174 8.52671 2.46085 9.37612L1.18794 11.4128C0.963393 11.7721 0.963395 12.2279 1.18794 12.5872L2.46085 14.6239C3.3213 16.0006 4.46494 17.1784 5.81576 18.0789L5.94933 18.1679C7.74121 19.3625 9.8466 20 12.0002 20C13.5116 20 14.9993 19.686 16.3715 19.0858L18.5982 21.3125C18.9887 21.703 19.6218 21.703 20.0124 21.3125C20.4029 20.922 20.4029 20.2888 20.0124 19.8983L4.00691 3.89287ZM14.8257 17.54L13.0353 15.7496C12.7056 15.8405 12.3583 15.889 11.9997 15.889C9.85196 15.889 8.11084 14.1479 8.11084 12.0001C8.11084 11.6415 8.15937 11.2943 8.25022 10.9646L5.77433 8.48871C5.15179 9.06078 4.60729 9.71541 4.15685 10.4361L3.17943 12L4.15685 13.5639C4.86685 14.6999 5.81053 15.6717 6.92516 16.4148L7.05873 16.5038C8.52208 17.4794 10.2415 18 12.0002 18C12.9658 18 13.9196 17.8431 14.8257 17.54Z",
      fill: "currentColor"
    }), /*#__PURE__*/external_react_default.a.createElement("path", {
      d: "M10.9657 8.25019L15.7496 13.0342C15.8402 12.7049 15.8886 12.3581 15.8886 12.0001C15.8886 9.85232 14.1475 8.11121 11.9997 8.11121C11.6417 8.11121 11.2949 8.15959 10.9657 8.25019Z",
      fill: "currentColor"
    }), /*#__PURE__*/external_react_default.a.createElement("path", {
      d: "M19.8435 13.5639C19.3932 14.2844 18.8488 14.939 18.2264 15.5109L19.6417 16.9262C20.3702 16.2467 21.0087 15.4731 21.5395 14.6239L22.8124 12.5872C23.037 12.2279 23.037 11.7721 22.8124 11.4128L21.5395 9.37612C20.6791 7.99942 19.5354 6.82164 18.1846 5.9211L18.051 5.83205C16.2591 4.63746 14.1538 4 12.0002 4C10.489 4 9.00149 4.31389 7.62941 4.91392L9.17525 6.45977C10.0811 6.15687 11.0347 6 12.0002 6C13.7589 6 15.4783 6.52059 16.9416 7.49615L17.0752 7.5852C18.1898 8.32829 19.1335 9.30013 19.8435 10.4361L20.8209 12L19.8435 13.5639Z",
      fill: "currentColor"
    }));
  }

  var size = density === 'compact' ? '20' : '24';
  return /*#__PURE__*/external_react_default.a.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/external_react_default.a.createElement("title", null, Object(i18n_["_"])('Hide password')), /*#__PURE__*/external_react_default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.00691 3.89287C3.61638 3.50234 2.98322 3.50235 2.5927 3.89287C2.20217 4.2834 2.20217 4.91656 2.5927 5.30708L4.35908 7.07346C3.63043 7.75302 2.99174 8.52671 2.46085 9.37612L1.18794 11.4128C0.963393 11.7721 0.963395 12.2279 1.18794 12.5872L2.46085 14.6239C3.3213 16.0006 4.46494 17.1784 5.81576 18.0789L5.94933 18.1679C7.74121 19.3625 9.8466 20 12.0002 20C13.5116 20 14.9993 19.686 16.3715 19.0858L18.5982 21.3125C18.9887 21.703 19.6218 21.703 20.0124 21.3125C20.4029 20.922 20.4029 20.2888 20.0124 19.8983L4.00691 3.89287ZM14.8257 17.54L13.0353 15.7496C12.7056 15.8405 12.3583 15.889 11.9997 15.889C9.85196 15.889 8.11084 14.1479 8.11084 12.0001C8.11084 11.6415 8.15937 11.2943 8.25022 10.9646L5.77433 8.48871C5.15179 9.06078 4.60729 9.71541 4.15685 10.4361L3.17943 12L4.15685 13.5639C4.86685 14.6999 5.81053 15.6717 6.92516 16.4148L7.05873 16.5038C8.52208 17.4794 10.2415 18 12.0002 18C12.9658 18 13.9196 17.8431 14.8257 17.54Z",
    fill: "currentColor"
  }), /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "M10.9657 8.25019L15.7496 13.0342C15.8402 12.7049 15.8886 12.3581 15.8886 12.0001C15.8886 9.85232 14.1475 8.11121 11.9997 8.11121C11.6417 8.11121 11.2949 8.15959 10.9657 8.25019Z",
    fill: "currentColor"
  }), /*#__PURE__*/external_react_default.a.createElement("path", {
    d: "M19.8435 13.5639C19.3932 14.2844 18.8488 14.939 18.2264 15.5109L19.6417 16.9262C20.3702 16.2467 21.0087 15.4731 21.5395 14.6239L22.8124 12.5872C23.037 12.2279 23.037 11.7721 22.8124 11.4128L21.5395 9.37612C20.6791 7.99942 19.5354 6.82164 18.1846 5.9211L18.051 5.83205C16.2591 4.63746 14.1538 4 12.0002 4C10.489 4 9.00149 4.31389 7.62941 4.91392L9.17525 6.45977C10.0811 6.15687 11.0347 6 12.0002 6C13.7589 6 15.4783 6.52059 16.9416 7.49615L17.0752 7.5852C18.1898 8.32829 19.1335 9.30013 19.8435 10.4361L20.8209 12L19.8435 13.5639Z",
    fill: "currentColor"
  }));
}

/* harmony default export */ var Text_IconOutlinedHide = (IconOutlinedHide);
// CONCATENATED MODULE: ./src/Text/IconOutlinedView.tsx
function IconOutlinedView_extends() { IconOutlinedView_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return IconOutlinedView_extends.apply(this, arguments); }






function IconOutlinedView(props) {
  var _useSplunkTheme = Object(themes_["useSplunkTheme"])(),
      family = _useSplunkTheme.family,
      density = _useSplunkTheme.density;

  if (family === 'enterprise') {
    return /*#__PURE__*/external_react_default.a.createElement(SVG_default.a, IconOutlinedView_extends({
      viewBox: "0 0 24 24",
      size: 1.2,
      screenReaderText: Object(i18n_["_"])('View password')
    }, props), /*#__PURE__*/external_react_default.a.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M15.7745 11.8654C15.7745 14.0132 14.0334 15.7543 11.8857 15.7543C9.73788 15.7543 7.99677 14.0132 7.99677 11.8654C7.99677 9.71762 9.73788 7.9765 11.8857 7.9765C14.0334 7.9765 15.7745 9.71762 15.7745 11.8654ZM13.7745 11.8654C13.7745 12.9086 12.9289 13.7543 11.8857 13.7543C10.8424 13.7543 9.99677 12.9086 9.99677 11.8654C9.99677 10.8222 10.8424 9.9765 11.8857 9.9765C12.9289 9.9765 13.7745 10.8222 13.7745 11.8654Z",
      fill: "currentColor"
    }), /*#__PURE__*/external_react_default.a.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11.8859 3.86536C9.73235 3.86536 7.62695 4.50282 5.83507 5.69741L5.7015 5.78646C4.35068 6.687 3.20704 7.86477 2.3466 9.24148L1.07369 11.2781C0.849136 11.6374 0.849137 12.0933 1.07369 12.4526L2.3466 14.4892C3.20704 15.8659 4.35068 17.0437 5.7015 17.9443L5.83507 18.0333C7.62695 19.2279 9.73235 19.8654 11.8859 19.8654C14.0395 19.8654 16.1449 19.2279 17.9368 18.0333L18.0703 17.9443C19.4212 17.0437 20.5648 15.8659 21.4252 14.4892L22.6982 12.4526C22.9227 12.0933 22.9227 11.6374 22.6982 11.2781L21.4252 9.24148C20.5648 7.86477 19.4212 6.687 18.0703 5.78645L17.9368 5.69741C16.1449 4.50282 14.0395 3.86536 11.8859 3.86536ZM6.94447 7.36151C8.40782 6.38594 10.1272 5.86536 11.8859 5.86536C13.6446 5.86536 15.364 6.38594 16.8274 7.36151L16.9609 7.45056C18.0756 8.19364 19.0193 9.16549 19.7293 10.3015L20.7067 11.8654L19.7293 13.4292C19.0193 14.5652 18.0756 15.5371 16.9609 16.2802L16.8274 16.3692C15.364 17.3448 13.6446 17.8654 11.8859 17.8654C10.1272 17.8654 8.40782 17.3448 6.94447 16.3692L6.8109 16.2802C5.69627 15.5371 4.75259 14.5652 4.04259 13.4292L3.06517 11.8654L4.04259 10.3015C4.75259 9.16549 5.69627 8.19364 6.8109 7.45056L6.94447 7.36151Z",
      fill: "currentColor"
    }));
  }

  var size = density === 'compact' ? '20' : '24';
  return /*#__PURE__*/external_react_default.a.createElement("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/external_react_default.a.createElement("title", null, Object(i18n_["_"])('View password')), /*#__PURE__*/external_react_default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7745 11.8654C15.7745 14.0132 14.0334 15.7543 11.8857 15.7543C9.73788 15.7543 7.99677 14.0132 7.99677 11.8654C7.99677 9.71762 9.73788 7.9765 11.8857 7.9765C14.0334 7.9765 15.7745 9.71762 15.7745 11.8654ZM13.7745 11.8654C13.7745 12.9086 12.9289 13.7543 11.8857 13.7543C10.8424 13.7543 9.99677 12.9086 9.99677 11.8654C9.99677 10.8222 10.8424 9.9765 11.8857 9.9765C12.9289 9.9765 13.7745 10.8222 13.7745 11.8654Z",
    fill: "currentColor"
  }), /*#__PURE__*/external_react_default.a.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8859 3.86536C9.73235 3.86536 7.62695 4.50282 5.83507 5.69741L5.7015 5.78646C4.35068 6.687 3.20704 7.86477 2.3466 9.24148L1.07369 11.2781C0.849136 11.6374 0.849137 12.0933 1.07369 12.4526L2.3466 14.4892C3.20704 15.8659 4.35068 17.0437 5.7015 17.9443L5.83507 18.0333C7.62695 19.2279 9.73235 19.8654 11.8859 19.8654C14.0395 19.8654 16.1449 19.2279 17.9368 18.0333L18.0703 17.9443C19.4212 17.0437 20.5648 15.8659 21.4252 14.4892L22.6982 12.4526C22.9227 12.0933 22.9227 11.6374 22.6982 11.2781L21.4252 9.24148C20.5648 7.86477 19.4212 6.687 18.0703 5.78645L17.9368 5.69741C16.1449 4.50282 14.0395 3.86536 11.8859 3.86536ZM6.94447 7.36151C8.40782 6.38594 10.1272 5.86536 11.8859 5.86536C13.6446 5.86536 15.364 6.38594 16.8274 7.36151L16.9609 7.45056C18.0756 8.19364 19.0193 9.16549 19.7293 10.3015L20.7067 11.8654L19.7293 13.4292C19.0193 14.5652 18.0756 15.5371 16.9609 16.2802L16.8274 16.3692C15.364 17.3448 13.6446 17.8654 11.8859 17.8654C10.1272 17.8654 8.40782 17.3448 6.94447 16.3692L6.8109 16.2802C5.69627 15.5371 4.75259 14.5652 4.04259 13.4292L3.06517 11.8654L4.04259 10.3015C4.75259 9.16549 5.69627 8.19364 6.8109 7.45056L6.94447 7.36151Z",
    fill: "currentColor"
  }));
}

/* harmony default export */ var Text_IconOutlinedView = (IconOutlinedView);
// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(3);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: external "@splunk/react-ui/Box"
var Box_ = __webpack_require__(8);
var Box_default = /*#__PURE__*/__webpack_require__.n(Box_);

// EXTERNAL MODULE: external "@splunk/react-ui/Button"
var Button_ = __webpack_require__(16);
var Button_default = /*#__PURE__*/__webpack_require__.n(Button_);

// CONCATENATED MODULE: ./src/Text/TextStyles.ts




var disabledStyles = Object(external_styled_components_["css"])(["&,&[type]{cursor:not-allowed;color:", ";&::placeholder{color:", ";}}"], Object(themes_["pick"])({
  enterprise: themes_["variables"].textDisabledColor,
  prisma: themes_["variables"].contentColorDisabled
}), Object(themes_["pick"])({
  enterprise: themes_["variables"].textDisabledColor,
  prisma: themes_["variables"].contentColorDisabled
}));
var buttonStyles = Object(external_styled_components_["css"])(["border-radius:", ";cursor:pointer;font-size:0.83333em;flex-grow:0;", ";&:not([disabled]){color:", ";}"], Object(themes_["pick"])({
  enterprise: themes_["variables"].borderRadius,
  prisma: '50%'
}), Object(themes_["pick"])({
  enterprise: Object(external_styled_components_["css"])(["width:", ";height:", ";"], themes_["variables"].inputHeight, themes_["variables"].inputHeight),
  prisma: {
    comfortable: Object(external_styled_components_["css"])(["width:26px;min-width:26px;min-height:26px;margin:8px;padding:0;"]),
    compact: Object(external_styled_components_["css"])(["width:22px;min-width:22px;min-height:22px;margin:8px;padding:0;"])
  }
}), Object(themes_["pick"])({
  enterprise: {
    light: themes_["variables"].gray60,
    dark: themes_["variables"].white
  },
  prisma: themes_["variables"].contentColorDefault
}));
var StyledClearButton = external_styled_components_default()(Button_default.a).withConfig({
  displayName: "TextStyles__StyledClearButton",
  componentId: "eg7n6t-0"
})(["display:none;visibility:hidden;", ""], buttonStyles);
var StyledSearchIconWrapper = external_styled_components_default.a.span.withConfig({
  displayName: "TextStyles__StyledSearchIconWrapper",
  componentId: "eg7n6t-1"
})(["", ";color:", ";pointer-events:none;padding:", ";&[disabled]{", ";}"], themes_["mixins"].reset('inline-block'), Object(themes_["pick"])({
  enterprise: {
    light: themes_["variables"].gray60,
    dark: themes_["variables"].white
  },
  prisma: themes_["variables"].contentColorMuted
}), Object(themes_["pick"])({
  comfortable: '0 8px',
  compact: '0 6px'
}), Object(themes_["pick"])({
  prisma: Object(external_styled_components_["css"])(["color:", ";"], themes_["variables"].contentColorDisabled)
}));
var StyledBox = external_styled_components_default()(Box_default.a).withConfig({
  displayName: "TextStyles__StyledBox",
  componentId: "eg7n6t-2"
})(["display:flex;justify-content:space-between;flex-grow:1;flex-shrink:1;position:relative;&[data-inline]{width:230px;flex-basis:230px;[data-inline] + &{margin-left:", ";}}&:focus-within:not([disabled]){", "{", "}", "{visibility:visible;display:block;}}", ""], Object(themes_["pick"])({
  enterprise: themes_["variables"].spacingHalf,
  prisma: themes_["variables"].spacingSmall
}),
/* sc-sel */
StyledSearchIconWrapper, Object(themes_["pick"])({
  enterprise: Object(external_styled_components_["css"])(["display:none;"])
}),
/* sc-sel */
StyledClearButton, function (_ref) {
  var $isTimeInput = _ref.$isTimeInput;
  return $isTimeInput && Object(external_styled_components_["css"])(["@media screen and (min--moz-device-pixel-ratio:0){", "{display:none;}}"],
  /* sc-sel */
  StyledClearButton);
});
var StyledInputWrapper = external_styled_components_default.a.span.withConfig({
  displayName: "TextStyles__StyledInputWrapper",
  componentId: "eg7n6t-3"
})(["", ";flex-grow:1;min-height:", ";position:relative;overflow:hidden;border:1px solid ", ";border-radius:", ";box-sizing:border-box;background-color:", ";box-shadow:inset 0 1px 1px rgba(0,0,0,0.075);padding:", ";align-items:center;", " ", " &:hover:not([disabled]){border-color:", ";}&:focus-within:not([disabled]){", "}", " ", " ", " ", " ", ""], themes_["mixins"].reset('inline-flex'), themes_["variables"].inputHeight, Object(themes_["pick"])({
  enterprise: {
    light: themes_["variables"].gray60,
    dark: themes_["variables"].gray20
  },
  prisma: themes_["variables"].interactiveColorBorder
}), themes_["variables"].borderRadius, Object(themes_["pick"])({
  enterprise: {
    light: themes_["variables"].white,
    dark: themes_["variables"].gray22
  },
  prisma: themes_["variables"].transparent
}), Object(themes_["pick"])({
  enterprise: '0px 10px',
  prisma: '0px 14px'
}), function (_ref2) {
  var $hasEndAdornment = _ref2.$hasEndAdornment;
  return $hasEndAdornment && Object(external_styled_components_["css"])(["padding-right:0;"]);
}, function (_ref3) {
  var $hasStartAdornment = _ref3.$hasStartAdornment;
  return $hasStartAdornment && Object(external_styled_components_["css"])(["padding-left:0;"]);
}, Object(themes_["pick"])({
  enterprise: {
    light: themes_["variables"].gray60,
    dark: themes_["variables"].gray20
  },
  prisma: themes_["variables"].interactiveColorBorderHover
}), Object(themes_["pick"])({
  enterprise: Object(external_styled_components_["css"])(["box-shadow:", ";color:", ";"], themes_["variables"].focusShadow, themes_["variables"].textColor),
  prisma: Object(external_styled_components_["css"])(["border-color:", ";color:", ";"], themes_["variables"].interactiveColorPrimary, themes_["variables"].contentColorActive)
}), function (_ref4) {
  var $error = _ref4.$error;
  return $error && Object(external_styled_components_["css"])(["&,&:hover{border-color:", ";}"], Object(themes_["pick"])({
    enterprise: themes_["variables"].errorColor,
    prisma: themes_["variables"].accentColorNegative
  }));
}, function (_ref5) {
  var $append = _ref5.$append;
  return $append && Object(external_styled_components_["css"])(["margin-right:-1px;border-top-right-radius:0;border-bottom-right-radius:0;border-right:none;"]);
}, function (_ref6) {
  var $prepend = _ref6.$prepend;
  return $prepend && Object(external_styled_components_["css"])(["border-top-left-radius:0;border-bottom-left-radius:0;"]);
}, function (_ref7) {
  var disabled = _ref7.disabled;
  return disabled && Object(external_styled_components_["css"])(["", " box-shadow:inset 0 1px 2px rgba(0,0,0,0.025);"], Object(themes_["pick"])({
    enterprise: {
      light: Object(external_styled_components_["css"])(["background-color:", ";border-color:", ";"], themes_["variables"].gray96, themes_["variables"].gray92),
      dark: Object(external_styled_components_["css"])(["background-color:", ";border-color:", ";"], themes_["variables"].gray22, themes_["variables"].gray30)
    },
    prisma: Object(external_styled_components_["css"])(["border-color:", ";"], themes_["variables"].interactiveColorBorderDisabled)
  }));
}, function (_ref8) {
  var $multiline = _ref8.$multiline;
  return $multiline && Object(themes_["pick"])({
    enterprise: Object(external_styled_components_["css"])(["padding-right:0;"])
  });
});
/* Some of these need greater specificity than input[type=text] */

var StyledInput = external_styled_components_default.a.input.withConfig({
  displayName: "TextStyles__StyledInput",
  componentId: "eg7n6t-4"
})(["", ";&,&[type]{outline-style:none;border:0;background:transparent;color:", ";flex-grow:1;font-family:", ";font-size:inherit;line-height:inherit;&[type='time']{&::-webkit-calendar-picker-indicator{display:none;}height:", ";@media screen and (min--moz-device-pixel-ratio:0){padding-right:", ";}}position:relative;&::placeholder{color:", ";opacity:1;}", " ", "}textarea&{resize:none;overflow:auto;padding-top:", ";padding-bottom:", ";padding-right:", ";}"], themes_["mixins"].reset('inline-flex'), Object(themes_["pick"])({
  enterprise: themes_["variables"].textColor,
  prisma: themes_["variables"].contentColorActive
}), themes_["variables"].sansFontFamily, Object(themes_["pick"])({
  enterprise: '20px',
  prisma: {
    comfortable: '24px',
    compact: '20px'
  }
}), Object(themes_["pick"])({
  enterprise: themes_["variables"].spacingHalf,
  prisma: '14px'
}), themes_["variables"].contentColorMuted, function (_ref9) {
  var $error = _ref9.$error;
  return $error && Object(external_styled_components_["css"])(["&,&:hover{color:", ";}"], Object(themes_["pick"])({
    enterprise: themes_["variables"].errorColor,
    prisma: themes_["variables"].contentColorActive
  }));
}, function (_ref10) {
  var disabled = _ref10.disabled;
  return disabled && disabledStyles;
}, Object(themes_["pick"])({
  enterprise: {
    comfortable: themes_["variables"].spacingQuarter,
    compact: '3px'
  },
  prisma: {
    comfortable: themes_["variables"].spacingSmall,
    compact: '5px'
  }
}), Object(themes_["pick"])({
  enterprise: {
    comfortable: themes_["variables"].spacingQuarter,
    compact: '3px'
  },
  prisma: {
    comfortable: themes_["variables"].spacingSmall,
    compact: '5px'
  }
}), Object(themes_["pick"])({
  enterprise: '10px',
  prisma: '14px'
}));
var StyledVisibilityToggle = external_styled_components_default()(Button_default.a).withConfig({
  displayName: "TextStyles__StyledVisibilityToggle",
  componentId: "eg7n6t-5"
})(["", ""], buttonStyles);
var StyledPlaceholder = external_styled_components_default.a.span.withConfig({
  displayName: "TextStyles__StyledPlaceholder",
  componentId: "eg7n6t-6"
})(["pointer-events:none;color:", ";position:absolute;overflow:hidden;font-size:inherit;line-height:inherit;height:", ";margin-right:", ";", ";", ";", ""], Object(themes_["pick"])({
  enterprise: themes_["variables"].textGray,
  prisma: themes_["variables"].contentColorMuted
}), themes_["variables"].lineHeight, Object(themes_["pick"])({
  enterprise: '10px',
  prisma: '14px'
}), function (_ref11) {
  var $hasStartAdornment = _ref11.$hasStartAdornment,
      $startAdornmentWidth = _ref11.$startAdornmentWidth;
  return $hasStartAdornment && ($startAdornmentWidth ? Object(external_styled_components_["css"])(["margin-left:", "px;"], $startAdornmentWidth) : Object(external_styled_components_["css"])(["margin-left:", ";"], Object(themes_["pick"])({
    enterprise: {
      comfortable: '30px',
      compact: '26px'
    },
    prisma: {
      comfortable: '38px',
      compact: '30px'
    }
  })));
}, function (_ref12) {
  var $hasEndAdornment = _ref12.$hasEndAdornment,
      $endAdornmentWidth = _ref12.$endAdornmentWidth;
  return $hasEndAdornment && ($endAdornmentWidth // calc(100% - padding - adorment width)
  ? Object(external_styled_components_["css"])(["max-width:calc( 100% - ", " - ", "px );"], Object(themes_["pick"])({
    enterprise: '10px',
    prisma: '14px'
  }), $endAdornmentWidth) : Object(external_styled_components_["css"])(["max-width:calc( 100% - ", " - ", " );"], Object(themes_["pick"])({
    enterprise: '10px',
    prisma: '14px'
  }), Object(themes_["pick"])({
    enterprise: {
      comfortable: '30px',
      compact: '26px'
    },
    prisma: {
      comfortable: '38px',
      compact: '30px'
    }
  })));
}, function (_ref13) {
  var $hasBothAdornment = _ref13.$hasBothAdornment,
      $endAdornmentWidth = _ref13.$endAdornmentWidth,
      $startAdornmentWidth = _ref13.$startAdornmentWidth;
  return $hasBothAdornment && Object(external_styled_components_["css"])(["max-width:calc(100% - ", "px - ", "px);"], $startAdornmentWidth, $endAdornmentWidth);
});
var adornmentHolder = Object(external_styled_components_["css"])(["display:inline-flex;align-items:center;justify-content:center;height:", ";pointer-events:none;"], Object(themes_["pick"])({
  enterprise: {
    comfortable: '30px',
    compact: '26px'
  },
  prisma: {
    comfortable: '38px',
    compact: '30px'
  }
}));
var StyledStartAdornmentHolder = external_styled_components_default.a.div.withConfig({
  displayName: "TextStyles__StyledStartAdornmentHolder",
  componentId: "eg7n6t-7"
})(["", " ", ";"], adornmentHolder, function (_ref14) {
  var $width = _ref14.$width;
  return $width ? Object(external_styled_components_["css"])(["min-width:", "px;"], $width) : Object(external_styled_components_["css"])(["min-width:", ";"], Object(themes_["pick"])({
    enterprise: {
      comfortable: '30px',
      compact: '26px'
    },
    prisma: {
      comfortable: '38px',
      compact: '30px'
    }
  }));
});
var StyledEndAdornmentHolder = external_styled_components_default.a.div.withConfig({
  displayName: "TextStyles__StyledEndAdornmentHolder",
  componentId: "eg7n6t-8"
})(["", " ", ";"], adornmentHolder, function (_ref15) {
  var $width = _ref15.$width;
  return $width ? Object(external_styled_components_["css"])(["min-width:", "px;"], $width) : Object(external_styled_components_["css"])(["min-width:", ";"], Object(themes_["pick"])({
    enterprise: {
      comfortable: '30px',
      compact: '26px'
    },
    prisma: {
      comfortable: '38px',
      compact: '30px'
    }
  }));
});
var StyledAdornment = external_styled_components_default.a.div.withConfig({
  displayName: "TextStyles__StyledAdornment",
  componentId: "eg7n6t-9"
})(["display:inline-flex;align-items:center;justify-content:center;position:absolute;pointer-events:none;z-index:1;height:", ";", ";", ";", ""], Object(themes_["pick"])({
  enterprise: {
    comfortable: '30px',
    compact: '26px'
  },
  prisma: {
    comfortable: '38px',
    compact: '30px'
  }
}), function (_ref16) {
  var $position = _ref16.$position;
  return $position === 'start' ? Object(external_styled_components_["css"])(["top:1px;left:1px;"]) : Object(external_styled_components_["css"])(["top:1px;right:1px;"]);
}, function (_ref17) {
  var disabled = _ref17.disabled;
  return disabled && disabledStyles;
}, Object(themes_["pick"])({
  enterprise: Object(external_styled_components_["css"])(["margin-left:-1px;margin-right:-1px;"])
}));

// CONCATENATED MODULE: ./src/Text/Text.tsx
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function Text_extends() { Text_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Text_extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

















/** @public */

var propTypes = {
  appearance: external_prop_types_default.a.oneOf(['default', 'search']),
  append: external_prop_types_default.a.bool,
  autoCapitalize: external_prop_types_default.a.string,
  autoComplete: external_prop_types_default.a.string,
  autoCorrect: external_prop_types_default.a.string,
  autoFocus: external_prop_types_default.a.bool,
  canClear: external_prop_types_default.a.bool,
  children: external_prop_types_default.a.node,

  /** @private. */
  classNamePrivate: external_prop_types_default.a.string,
  defaultValue: external_prop_types_default.a.string,
  describedBy: external_prop_types_default.a.string,
  disabled: external_prop_types_default.a.bool,
  elementRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.object]),
  endAdornment: external_prop_types_default.a.node,
  error: external_prop_types_default.a.bool,
  inline: external_prop_types_default.a.bool,

  /** @private. */
  inputClassName: external_prop_types_default.a.string,
  inputId: external_prop_types_default.a.string,
  inputRef: external_prop_types_default.a.oneOfType([external_prop_types_default.a.func, external_prop_types_default.a.object]),
  labelledBy: external_prop_types_default.a.string,
  maxLength: external_prop_types_default.a.number,
  multiline: external_prop_types_default.a.bool,
  name: external_prop_types_default.a.string,
  onBlur: external_prop_types_default.a.func,
  onChange: external_prop_types_default.a.func,
  onFocus: external_prop_types_default.a.func,
  onKeyDown: external_prop_types_default.a.func,
  onSelect: external_prop_types_default.a.func,
  placeholder: external_prop_types_default.a.string,
  prepend: external_prop_types_default.a.bool,
  rowsMax: external_prop_types_default.a.number,
  rowsMin: external_prop_types_default.a.number,
  spellCheck: external_prop_types_default.a.bool,
  tabIndex: external_prop_types_default.a.number,
  startAdornment: external_prop_types_default.a.node,

  /** @private */
  splunkTheme: external_prop_types_default.a.object,
  type: external_prop_types_default.a.string,
  passwordVisibilityToggle: external_prop_types_default.a.bool,
  useSyntheticPlaceholder: external_prop_types_default.a.bool,
  value: external_prop_types_default.a.string
};
var defaultProps = {
  appearance: 'default',
  append: false,
  autoFocus: false,
  canClear: false,
  disabled: false,
  error: false,
  inline: false,
  multiline: false,
  placeholder: '',
  prepend: false,
  rowsMax: 8,
  rowsMin: 2,
  tabIndex: 0,
  type: 'text',
  passwordVisibilityToggle: false,
  useSyntheticPlaceholder: false
};

/** Note: Text places role and aria props onto the input. All other props are placed on the wrapper. */
var Text_Text = /*#__PURE__*/function (_Component) {
  _inherits(Text, _Component);

  var _super = _createSuper(Text);

  _createClass(Text, null, [{
    key: "validateRows",
    // @docs-props-type TextPropsBase
    value: function validateRows(_ref) {
      var rowsMin = _ref.rowsMin,
          rowsMax = _ref.rowsMax;

      if (false) {}
    }
  }]);

  function Text(props) {
    var _this;

    _classCallCheck(this, Text);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "controlledExternally", void 0);

    _defineProperty(_assertThisInitialized(_this), "input", null);

    _defineProperty(_assertThisInitialized(_this), "shadow", null);

    _defineProperty(_assertThisInitialized(_this), "startAdornment", null);

    _defineProperty(_assertThisInitialized(_this), "endAdornment", null);

    _defineProperty(_assertThisInitialized(_this), "getAdornmentWidth", function () {
      var startIconRect = _this.startAdornment ? _this.startAdornment.getBoundingClientRect() : undefined;
      var startIconWidth = startIconRect && Math.round(startIconRect.width);

      if (_this.state.startAdornmentWidth !== startIconWidth) {
        _this.setState({
          startAdornmentWidth: startIconWidth
        });
      }

      var endIconRect = _this.endAdornment ? _this.endAdornment.getBoundingClientRect() : undefined;
      var endIconWidth = endIconRect && Math.round(endIconRect.width);

      if (_this.state.endAdornmentWidth !== endIconWidth) {
        _this.setState({
          endAdornmentWidth: endIconWidth
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
      _this.syncHeightWithShadow();
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputMount", function (el) {
      _this.input = el;
      Object(updateReactRef["a" /* updateReactRef */])(_this.props.inputRef, el);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputChange", function (e) {
      var _this$props$onChange, _this$props;

      var value = e.target.value;
      var name = _this.props.name;

      if (!_this.isControlled()) {
        _this.setState({
          value: value
        });
      }

      (_this$props$onChange = (_this$props = _this.props).onChange) === null || _this$props$onChange === void 0 ? void 0 : _this$props$onChange.call(_this$props, e, {
        value: value,
        name: name
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputKeyDown", function (e) {
      var _this$props$onKeyDown, _this$props2;

      (_this$props$onKeyDown = (_this$props2 = _this.props).onKeyDown) === null || _this$props$onKeyDown === void 0 ? void 0 : _this$props$onKeyDown.call(_this$props2, e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputSelect", function (e) {
      var _this$props$onSelect, _this$props3;

      (_this$props$onSelect = (_this$props3 = _this.props).onSelect) === null || _this$props$onSelect === void 0 ? void 0 : _this$props$onSelect.call(_this$props3, e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputFocus", function (e) {
      var _this$props$onFocus, _this$props4;

      (_this$props$onFocus = (_this$props4 = _this.props).onFocus) === null || _this$props$onFocus === void 0 ? void 0 : _this$props$onFocus.call(_this$props4, e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleInputBlur", function (e) {
      var _this$props$onBlur, _this$props5;

      (_this$props$onBlur = (_this$props5 = _this.props).onBlur) === null || _this$props$onBlur === void 0 ? void 0 : _this$props$onBlur.call(_this$props5, e);
    });

    _defineProperty(_assertThisInitialized(_this), "handleClear", function (e) {
      // Only respond to left mouse button.
      if (e.button === 0) {
        var _this$props$onChange2, _this$props6;

        e.preventDefault();
        var value = '';
        var name = _this.props.name;

        if (!_this.isControlled()) {
          _this.setState({
            value: value
          });
        }

        (_this$props$onChange2 = (_this$props6 = _this.props).onChange) === null || _this$props$onChange2 === void 0 ? void 0 : _this$props$onChange2.call(_this$props6, e, {
          value: value,
          name: name
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleVisibilityToggle", function () {
      _this.setState(function (state) {
        return {
          hideVisibility: !state.hideVisibility
        };
      });
    });

    _defineProperty(_assertThisInitialized(_this), "syncHeightWithShadow", function () {
      var newHeight = syncHeightWithShadow({
        height: _this.state.height,
        multiline: _this.props.multiline,
        rowsMax: _this.props.rowsMax,
        rowsMin: _this.props.rowsMin,
        shadow: _this.shadow
      });

      if (newHeight !== false) {
        _this.setState({
          height: newHeight
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderEndAdornment", function () {
      var _controlGroupContext$;

      var _this$props7 = _this.props,
          appearance = _this$props7.appearance,
          endAdornment = _this$props7.endAdornment,
          passwordVisibilityToggle = _this$props7.passwordVisibilityToggle,
          disabled = _this$props7.disabled,
          canClear = _this$props7.canClear,
          splunkTheme = _this$props7.splunkTheme;
      var isPrisma = (splunkTheme === null || splunkTheme === void 0 ? void 0 : splunkTheme.family) === 'prisma';
      var adornmentProps = {
        ref: function ref(el) {
          _this.endAdornment = el;
        },
        disabled: disabled,
        $position: 'end'
      };

      if (endAdornment) {
        return /*#__PURE__*/external_react_default.a.createElement(StyledAdornment, adornmentProps, endAdornment);
      }

      if (passwordVisibilityToggle && !disabled) {
        var eyeIcon = _this.state.hideVisibility ? /*#__PURE__*/external_react_default.a.createElement(Text_IconOutlinedView, null) : /*#__PURE__*/external_react_default.a.createElement(Text_IconOutlinedHide, null);
        return /*#__PURE__*/external_react_default.a.createElement(StyledAdornment, adornmentProps, /*#__PURE__*/external_react_default.a.createElement(StyledVisibilityToggle, {
          appearance: isPrisma ? 'secondary' : 'pill',
          "data-test": "password-toggle",
          inline: false,
          onClick: _this.handleVisibilityToggle,
          type: "button",
          icon: eyeIcon
        }));
      }

      var controlGroupContext = _this.context;
      var controlGroupLabel = (_controlGroupContext$ = controlGroupContext.labelAttrs) === null || _controlGroupContext$ === void 0 ? void 0 : _controlGroupContext$.text;
      var clearButtonText = controlGroupLabel ? Object(i18n_["_"])("Clear ".concat(controlGroupLabel, " text field")) : Object(i18n_["_"])('Clear text field');

      if (!isPrisma && appearance === 'search') {
        return /*#__PURE__*/external_react_default.a.createElement(StyledAdornment, adornmentProps, /*#__PURE__*/external_react_default.a.createElement(StyledClearButton, {
          appearance: isPrisma ? 'secondary' : 'pill',
          "data-test": "clear",
          inline: false,
          icon: /*#__PURE__*/external_react_default.a.createElement(CrossMark["a" /* default */], {
            enterpriseSize: 1,
            screenReaderText: clearButtonText
          }),
          onClick: _this.handleClear
        }), /*#__PURE__*/external_react_default.a.createElement(StyledSearchIconWrapper, {
          $disabled: disabled
        }, /*#__PURE__*/external_react_default.a.createElement(Search, {
          enterpriseSize: "16px",
          inline: false
        })));
      }

      if (isPrisma && appearance === 'search' || canClear) {
        return /*#__PURE__*/external_react_default.a.createElement(StyledAdornment, adornmentProps, /*#__PURE__*/external_react_default.a.createElement(StyledClearButton, {
          "data-test": "clear",
          appearance: isPrisma ? 'secondary' : 'pill',
          onClick: _this.handleClear,
          icon: /*#__PURE__*/external_react_default.a.createElement(CrossMark["a" /* default */], {
            inline: false,
            enterpriseSize: 1,
            screenReaderText: clearButtonText
          })
        }));
      }

      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "renderStartAdornment", function () {
      var _this$props8 = _this.props,
          appearance = _this$props8.appearance,
          startAdornment = _this$props8.startAdornment,
          splunkTheme = _this$props8.splunkTheme,
          disabled = _this$props8.disabled;
      var isPrisma = (splunkTheme === null || splunkTheme === void 0 ? void 0 : splunkTheme.family) === 'prisma';
      var adornmentProps = {
        ref: function ref(el) {
          _this.startAdornment = el;
        },
        disabled: disabled,
        $position: 'start'
      };

      if (startAdornment) {
        return /*#__PURE__*/external_react_default.a.createElement(StyledAdornment, adornmentProps, startAdornment);
      }

      if (isPrisma && appearance === 'search') {
        return /*#__PURE__*/external_react_default.a.createElement(StyledAdornment, adornmentProps, /*#__PURE__*/external_react_default.a.createElement(StyledSearchIconWrapper, {
          $disabled: disabled
        }, /*#__PURE__*/external_react_default.a.createElement(Search, {
          enterpriseSize: "16px",
          inline: false
        })));
      }

      return undefined;
    });

    _this.controlledExternally = Object(external_lodash_["has"])(props, 'value');
    _this.state = {
      value: props.defaultValue || '',
      hideVisibility: true
    };

    if (false) {}

    if (false) {}

    Text.validateRows(props);
    _this.handleResize = Object(external_lodash_["throttle"])(_this.handleResize, 100);
    return _this;
  }

  _createClass(Text, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      Object(external_lodash_["defer"])(this.syncHeightWithShadow); // wait for styles to load

      this.getAdornmentWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.multiline) {
        this.syncHeightWithShadow();
      }

      if (false) {}

      if (false) {}

      Text.validateRows(this.props);
      this.getAdornmentWidth();
    }
  }, {
    key: "isControlled",
    value: function isControlled() {
      return this.controlledExternally;
    }
  }, {
    key: "blur",
    value: function blur() {
      var _this$input;

      (_this$input = this.input) === null || _this$input === void 0 ? void 0 : _this$input.blur();
    }
    /**
     * Place focus on the input.
     */

  }, {
    key: "focus",
    value: function focus() {
      var _this$input2;

      (_this$input2 = this.input) === null || _this$input2 === void 0 ? void 0 : _this$input2.focus();
    }
  }, {
    key: "select",
    value: function select() {
      var _this$input3;

      (_this$input3 = this.input) === null || _this$input3 === void 0 ? void 0 : _this$input3.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props9 = this.props,
          append = _this$props9.append,
          autoCapitalize = _this$props9.autoCapitalize,
          autoComplete = _this$props9.autoComplete,
          autoCorrect = _this$props9.autoCorrect,
          autoFocus = _this$props9.autoFocus,
          children = _this$props9.children,
          className = _this$props9.className,
          classNamePrivate = _this$props9.classNamePrivate,
          disabled = _this$props9.disabled,
          describedBy = _this$props9.describedBy,
          elementRef = _this$props9.elementRef,
          error = _this$props9.error,
          inline = _this$props9.inline,
          inputClassName = _this$props9.inputClassName,
          inputId = _this$props9.inputId,
          labelledBy = _this$props9.labelledBy,
          multiline = _this$props9.multiline,
          maxLength = _this$props9.maxLength,
          name = _this$props9.name,
          passwordVisibilityToggle = _this$props9.passwordVisibilityToggle,
          placeholder = _this$props9.placeholder,
          prepend = _this$props9.prepend,
          spellCheck = _this$props9.spellCheck,
          tabIndex = _this$props9.tabIndex,
          title = _this$props9.title,
          type = _this$props9.type,
          useSyntheticPlaceholder = _this$props9.useSyntheticPlaceholder,
          value = _this$props9.value,
          otherProps = _objectWithoutProperties(_this$props9, ["append", "autoCapitalize", "autoComplete", "autoCorrect", "autoFocus", "children", "className", "classNamePrivate", "disabled", "describedBy", "elementRef", "error", "inline", "inputClassName", "inputId", "labelledBy", "multiline", "maxLength", "name", "passwordVisibilityToggle", "placeholder", "prepend", "spellCheck", "tabIndex", "title", "type", "useSyntheticPlaceholder", "value"]);

      var ariaProps = _objectSpread(_objectSpread({}, Object(external_lodash_["pickBy"])(otherProps, function (val, key) {
        return key === 'role' || key.indexOf('aria-') === 0;
      })), {}, {
        'aria-describedby': describedBy,
        'aria-labelledby': labelledBy,
        'aria-invalid': error || undefined,
        'aria-multiline': multiline
      });

      var boxProps = Object(external_lodash_["omit"])(otherProps, ['inputRef', 'onBlur', 'onChange', 'onFocus', 'onKeyDown', 'onSelect', 'rowsMax', 'rowsMin'].concat(_toConsumableArray(Object(external_lodash_["keys"])(ariaProps))));
      var displayValue = this.isControlled() ? value : this.state.value;
      var displayProps = {
        className: Object(style_["toClassName"])(className, inputClassName),
        $append: append || undefined,
        $error: error,
        $prepend: prepend || undefined
      };
      var passwordVisibility = this.state.hideVisibility ? 'password' : 'text';
      var computedType = passwordVisibilityToggle ? passwordVisibility : type;

      var inputProps = _objectSpread(_objectSpread({}, ariaProps), {}, {
        'data-test': 'textbox',
        autoCapitalize: autoCapitalize,
        autoComplete: autoComplete,
        autoCorrect: autoCorrect,
        autoFocus: autoFocus,
        id: inputId,
        maxLength: maxLength,
        placeholder: placeholder && !useSyntheticPlaceholder ? placeholder : undefined,
        name: name,
        onChange: this.handleInputChange,
        onKeyDown: this.handleInputKeyDown,
        onSelect: this.handleInputSelect,
        onFocus: this.handleInputFocus,
        onBlur: this.handleInputBlur,
        ref: this.handleInputMount,
        role: 'textbox',
        spellCheck: spellCheck,
        style: {
          height: this.state.height
        },
        title: title,
        tabIndex: tabIndex,
        type: multiline ? null : computedType,
        value: displayValue,
        $error: error
      });

      var haveSyntheticPlaceholder = useSyntheticPlaceholder && placeholder && !displayValue; // Do not render value in DOM when type is password, or passwordVisibiltyToggle is enabled

      var dataTestValue = type === 'password' || passwordVisibilityToggle ? undefined : displayValue; // Firefox hack (SUI-2716). Remove when fixed: https://bugzilla.mozilla.org/show_bug.cgi?id=1427173

      var isTimeInput = type === 'time';
      var hasEndAdornment = !!this.renderEndAdornment();
      var hasStartAdornment = !!this.renderStartAdornment();
      return /*#__PURE__*/external_react_default.a.createElement(StyledBox, Text_extends({
        $isTimeInput: isTimeInput,
        className: Object(style_["toClassName"])(className, classNamePrivate),
        "data-test": "text",
        "data-test-value": dataTestValue,
        elementRef: elementRef,
        flex: true,
        inline: inline
      }, boxProps), this.renderStartAdornment(), /*#__PURE__*/external_react_default.a.createElement(StyledInputWrapper, Text_extends({
        $hasEndAdornment: hasEndAdornment,
        $hasStartAdornment: hasStartAdornment,
        $multiline: multiline,
        disabled: disabled
      }, displayProps), hasStartAdornment && /*#__PURE__*/external_react_default.a.createElement(StyledStartAdornmentHolder, {
        $width: this.state.startAdornmentWidth
      }), !disabled && multiline && /*#__PURE__*/external_react_default.a.createElement(StyledInput, {
        as: "textarea",
        "aria-hidden": "true",
        onChange: external_lodash_["noop"],
        style: {
          width: '100%',
          position: 'absolute',
          overflow: 'hidden',
          left: -10000,
          top: -10000
        },
        tabIndex: -1,
        ref: function ref(el) {
          _this2.shadow = el;
        },
        value: displayValue
      }), disabled ? /*#__PURE__*/external_react_default.a.createElement(StyledInput, Text_extends({
        as: multiline ? 'textarea' : undefined,
        className: Object(style_["toClassName"])(className, classNamePrivate),
        "data-multiline": multiline || null,
        "data-test": "disabled-textbox",
        disabled: true,
        readOnly: true,
        style: multiline ? {
          height: this.state.height
        } : undefined // @ts-expect-error - accept: type only exists on input (see "as" prop)
        ,
        type: multiline ? undefined : computedType,
        value: displayValue,
        placeholder: placeholder && !useSyntheticPlaceholder ? placeholder : undefined,
        ref: multiline ? function (el) {
          _this2.shadow = el;
        } : undefined
      }, ariaProps)) : /*#__PURE__*/external_react_default.a.createElement(StyledInput, Text_extends({
        as: multiline ? 'textarea' : undefined
      }, inputProps)), !disabled && multiline && /*#__PURE__*/external_react_default.a.createElement(external_react_event_listener_default.a, {
        target: "window",
        onResize: this.handleResize
      }), haveSyntheticPlaceholder && /*#__PURE__*/external_react_default.a.createElement(ScreenReaderContent_default.a, null, placeholder), haveSyntheticPlaceholder && /*#__PURE__*/external_react_default.a.createElement(StyledPlaceholder, {
        $endAdornmentWidth: this.state.endAdornmentWidth,
        $hasBothAdornment: hasStartAdornment && hasEndAdornment // used to calculate the max-width
        ,
        $hasEndAdornment: hasEndAdornment,
        $hasStartAdornment: hasStartAdornment,
        $startAdornmentWidth: this.state.startAdornmentWidth,
        "aria-hidden": true,
        "data-role": "placeholder"
      }, placeholder), children, hasEndAdornment && /*#__PURE__*/external_react_default.a.createElement(StyledEndAdornmentHolder, {
        $width: this.state.endAdornmentWidth
      })), this.renderEndAdornment());
    }
  }]);

  return Text;
}(external_react_["Component"]);

_defineProperty(Text_Text, "propTypes", propTypes);

_defineProperty(Text_Text, "defaultProps", defaultProps);

_defineProperty(Text_Text, "componentType", 'Text');

_defineProperty(Text_Text, "contextType", ControlGroup_["ControlGroupContext"]);

var TextWithThemeBase = Object(themes_["withSplunkTheme"])(Text_Text);
var TextWithTheme = TextWithThemeBase;
TextWithTheme.propTypes = Text_Text.propTypes;
TextWithTheme.componentType = Text_Text.componentType;
/* harmony default export */ var src_Text_Text = (TextWithTheme);
// CONCATENATED MODULE: ./src/Text/index.ts



/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return updateReactRef; });
/**
 * Updates a React ref. Callback refs and object refs (from `createRef` and `useRef`) are supported.
 *
 * @param ref - The React callback or object ref. Can be `null` or `undefined`.
 * @param current - The new value of the ref.
 */
function updateReactRef(ref, current) {
  if (ref) {
    if (typeof ref === 'function') {
      ref(current);
    } else {
      // the public signature of this util uses React.Ref<T> to mirror the way React types refs.
      // the intention here is to signal "we will take care of setting 'current', not you".
      ref.current = current; // eslint-disable-line no-param-reassign
    }
  }
}



/***/ }),

/***/ 14:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/ScreenReaderContent");

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = require("react-event-listener");

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Button");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CrossMark; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _splunk_react_icons_Close__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25);
/* harmony import */ var _splunk_react_icons_Close__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_splunk_react_icons_Close__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _ThemedIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* harmony import */ var _SVG__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }






function Prisma24(_ref) {
  var otherProps = _extends({}, _ref);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_SVG__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _extends({
    viewBox: "0 0 24 24"
  }, otherProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
    d: "M6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.2929 17.2929C4.90238 17.6834 4.90238 18.3166 5.2929 18.7071C5.68342 19.0976 6.31659 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289Z",
    fill: "currentColor"
  }));
}

function Prisma16(_ref2) {
  var otherProps = _extends({}, _ref2);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_SVG__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], _extends({
    viewBox: "0 0 16 16"
  }, otherProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("path", {
    d: "M12.2024 2.69009C12.5092 2.38325 13.0067 2.38325 13.3136 2.69009C13.6204 2.99693 13.6204 3.49442 13.3136 3.80126L9.11721 7.99762L13.3114 12.1918C13.6206 12.501 13.6206 13.0023 13.3114 13.3114C13.0023 13.6206 12.501 13.6206 12.1918 13.3114L7.99762 9.11721L3.885 13.2298C3.57816 13.5367 3.08067 13.5367 2.77383 13.2298C2.46699 12.923 2.46699 12.4255 2.77383 12.1187L6.88645 8.00604L2.69183 3.81142C2.38267 3.50226 2.38267 3.001 2.69183 2.69183C3.001 2.38267 3.50226 2.38267 3.81142 2.69183L8.00604 6.88646L12.2024 2.69009Z",
    fill: "currentColor"
  }));
}

function CrossMark(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_ThemedIcon__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], _extends({
    Enterprise: _splunk_react_icons_Close__WEBPACK_IMPORTED_MODULE_1___default.a,
    Prisma16: Prisma16,
    Prisma24: Prisma24
  }, props));
}

/***/ }),

/***/ 22:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/SVG");

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-icons/Close");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("styled-components");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = require("lodash");

/***/ }),

/***/ 40:
/***/ (function(module, exports) {

module.exports = require("@splunk/ui-utils/style");

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@splunk/ui-utils/i18n");

/***/ }),

/***/ 6:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SVG; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var Styled = styled_components__WEBPACK_IMPORTED_MODULE_1___default.a.svg.withConfig({
  displayName: "SVG__Styled",
  componentId: "sc-1bz0ryh-0"
})(["flex:0 0 auto;"]);
function SVG(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Styled, _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props));
}

/***/ }),

/***/ 7:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Icon; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _splunk_themes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var _splunk_themes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_splunk_themes__WEBPACK_IMPORTED_MODULE_2__);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var inlineStyles = {
  display: 'inline-block',
  flex: '0 0 auto',
  overflow: 'visible',
  verticalAlign: 'middle'
};
var blockStyles = {
  display: 'block',
  flex: '0 0 auto',
  margin: '0 auto',
  overflow: 'visible'
};
var propTypes = {
  Enterprise: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  enterpriseSize: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
  enterpriseWidth: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
  enterpriseHeight: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.number, prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string]),
  Prisma24: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func.isRequired,
  Prisma20: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  Prisma16: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func,
  prismaSize: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.oneOf(['medium', 'small']),
  inline: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool,
  screenReaderText: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string
};
var defaultProps = {
  inline: true,
  prismaSize: 'medium'
};
function Icon(_ref) {
  var Enterprise = _ref.Enterprise,
      Prisma24 = _ref.Prisma24,
      Prisma20 = _ref.Prisma20,
      Prisma16 = _ref.Prisma16,
      prismaSize = _ref.prismaSize,
      inline = _ref.inline,
      enterpriseSize = _ref.enterpriseSize,
      enterpriseWidth = _ref.enterpriseWidth,
      enterpriseHeight = _ref.enterpriseHeight,
      screenReaderText = _ref.screenReaderText,
      otherProps = _objectWithoutProperties(_ref, ["Enterprise", "Prisma24", "Prisma20", "Prisma16", "prismaSize", "inline", "enterpriseSize", "enterpriseWidth", "enterpriseHeight", "screenReaderText"]);

  var _useSplunkTheme = Object(_splunk_themes__WEBPACK_IMPORTED_MODULE_2__["useSplunkTheme"])(),
      family = _useSplunkTheme.family,
      density = _useSplunkTheme.density; // Enterprise - all variants


  if (family === 'enterprise') {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Enterprise, _extends({
      size: enterpriseSize,
      width: enterpriseWidth,
      height: enterpriseHeight,
      screenReaderText: screenReaderText || null,
      hideDefaultTooltip: true,
      inline: inline
    }, otherProps));
  }

  var prismaProps = _objectSpread({
    'aria-label': screenReaderText,
    style: inline ? inlineStyles : blockStyles
  }, otherProps); // Prisma - small+compact, small+comfortable


  if (prismaSize === 'small') {
    var SVG = Prisma16 || Prisma24;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SVG, _extends({
      width: "16",
      height: "16"
    }, prismaProps));
  } // Prisma - medium+compact


  if (density === 'compact') {
    var _SVG = Prisma20 || Prisma24;

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_SVG, _extends({
      width: "20",
      height: "20"
    }, prismaProps));
  } // Prisma - medium+comfortable


  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Prisma24, _extends({
    width: "24",
    height: "24"
  }, prismaProps));
}
Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@splunk/react-ui/Box");

/***/ })

/******/ });